import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'
import {
  IBusinessUpshifter,
  IBusinessUpshiftersCount,
  IGetBusinessUpshiftersCountParams,
  TGetBusinessUpshiftersParams,
  IAddToMultipleRostersParams,
} from 'models/BusinessUpshifter'

export class BusinessUpshiftersApi {
  constructor(private axios: AxiosService) {}

  getBusinessUpshifters = async (params: TGetBusinessUpshiftersParams) => {
    const response = await this.axios.get<IPayload<IBusinessUpshifter[]>>(
      Endpoints.getBusinessUpshifters,
      params
    )
    return response
  }

  getBusinessUpshiftersCount = async (params: IGetBusinessUpshiftersCountParams) => {
    const response = await this.axios.get<IPayload<IBusinessUpshiftersCount>>(
      Endpoints.getBusinessUpshiftersCount,
      params
    )
    return response
  }

  addToMultipleRosters = async (id: number, params: IAddToMultipleRostersParams) => {
    const response = await this.axios.post(Endpoints.addToMultipleRosters(id), params)
    return response
  }
}
